import React, { useState } from "react";
import Visa from "../assets/VISA.png";
import Diner from "../assets/DinersClub.png";
import Master from "../assets/Mastercard-Schwarz.png";

import Plane from "../assets/plane.png";
import Train from "../assets/train.png";
import Cruise from "../assets/cruise.png";

import PlaneSVG from "../assets/plane.svg";
import TrainSVG from "../assets/train.svg";
import CruiseSVG from "../assets/cruise.svg";

//let content = [Visa, Diner, Master];

//let content = [Plane, Train, Cruise];

let content = [PlaneSVG, TrainSVG, CruiseSVG];

let contentidx = 0;

const imgchange = () => {
  let tmp = document.getElementsByClassName("animationsvg");
  if (tmp.length > 0) {
    for (let i = 0; i < tmp.length; i++) {
      tmp[i].style.display = "none";
    }
    if (contentidx === content.length - 1) {
      contentidx = 0;
    } else {
      contentidx++;
    }
    tmp[contentidx].style.display = "block";
  }
  setTimeout(imgchange, 2000);
};

imgchange();

export default function Loading(props) {
  return (
    <>
      <div
        style={{
          width: "100px",
          height: "100px",
          margin: "auto",
          marginTop: "20%",
        }}
      >
        <svg className="animationsvg" viewBox="0 0 517 517">
          <path
            d="M 236.00,224.00
            C 236.00,224.00 184.00,189.34 184.00,189.34
              184.00,189.34 77.00,117.00 77.00,117.00
              77.00,117.00 35.00,88.67 35.00,88.67
              31.20,86.13 19.97,79.48 18.19,75.91
              15.98,71.45 19.93,68.08 23.00,65.44
              23.00,65.44 43.00,49.40 43.00,49.40
              45.49,47.41 49.93,43.38 53.00,42.88
              55.35,42.50 68.74,46.52 72.00,47.42
              72.00,47.42 116.00,59.86 116.00,59.86
              116.00,59.86 271.00,103.42 271.00,103.42
              271.00,103.42 314.00,115.42 314.00,115.42
              317.30,116.34 329.46,120.30 332.00,119.89
              335.47,119.32 340.49,113.56 342.99,111.00
              342.99,111.00 368.01,84.00 368.01,84.00
              368.01,84.00 401.96,48.00 401.96,48.00
              416.11,33.20 420.90,26.89 439.00,15.81
              451.42,8.21 465.22,2.02 480.00,2.00
              480.00,2.00 486.00,2.00 486.00,2.00
              489.73,2.05 491.36,2.20 495.00,3.16
              513.33,7.98 514.18,21.90 514.00,38.00
              513.84,51.53 506.61,66.70 499.58,78.00
              486.16,99.55 472.10,110.22 454.00,127.09
              454.00,127.09 430.00,149.91 430.00,149.91
              430.00,149.91 405.00,173.01 405.00,173.01
              402.44,175.51 396.68,180.53 396.11,184.00
              395.70,186.54 399.66,198.70 400.58,202.00
              400.58,202.00 412.58,245.00 412.58,245.00
              412.58,245.00 456.14,400.00 456.14,400.00
              456.14,400.00 468.58,444.00 468.58,444.00
              469.48,447.26 473.50,460.65 473.12,463.00
              472.62,466.07 468.59,470.51 466.60,473.00
              466.60,473.00 450.56,493.00 450.56,493.00
              447.92,496.07 444.55,500.02 440.09,497.81
              436.52,496.03 429.87,484.80 427.33,481.00
              427.33,481.00 399.00,439.00 399.00,439.00
              399.00,439.00 328.66,335.00 328.66,335.00
              328.66,335.00 305.66,301.00 305.66,301.00
              300.97,294.11 295.67,287.52 292.00,280.00
              284.26,285.37 271.26,298.03 264.00,304.96
              264.00,304.96 243.00,324.09 243.00,324.09
              243.00,324.09 221.00,344.58 221.00,344.58
              221.00,344.58 200.00,363.99 200.00,363.99
              197.95,365.98 193.53,369.48 192.77,372.09
              192.14,374.23 193.51,380.53 193.92,383.00
              193.92,383.00 197.61,405.00 197.61,405.00
              197.61,405.00 210.41,480.00 210.41,480.00
              212.30,492.15 205.54,497.30 198.00,506.00
              195.34,509.07 192.37,513.29 188.00,513.72
              181.84,514.31 176.35,502.68 173.42,498.00
              173.42,498.00 138.68,443.00 138.68,443.00
              138.68,443.00 128.58,427.01 128.58,427.01
              127.22,424.91 125.77,421.89 122.82,422.99
              122.82,422.99 108.00,433.56 108.00,433.56
              95.39,441.59 85.96,445.00 71.00,445.00
              71.00,429.44 75.01,418.86 83.75,406.00
              85.57,403.31 94.38,393.60 93.04,390.90
              92.24,389.29 88.56,387.17 87.00,386.19
              87.00,386.19 74.00,377.95 74.00,377.95
              74.00,377.95 23.00,345.68 23.00,345.68
              19.53,343.50 5.38,335.02 3.60,332.67
              2.52,331.25 2.11,329.77 2.28,328.00
              2.71,323.63 6.93,320.66 10.00,318.00
              17.72,311.30 24.05,303.75 35.00,305.44
              35.00,305.44 110.00,318.20 110.00,318.20
              110.00,318.20 133.00,322.08 133.00,322.08
              135.47,322.49 141.77,323.86 143.91,323.23
              146.52,322.47 150.02,318.05 152.01,316.00
              152.01,316.00 171.42,295.00 171.42,295.00
              171.42,295.00 191.91,273.00 191.91,273.00
              191.91,273.00 211.04,252.00 211.04,252.00
              217.97,244.74 230.63,231.74 236.00,224.00 Z"
          ></path>
        </svg>
        <svg className="animationsvg" viewBox="0 0 517 517">
          <path
            d="M 174.00,2.52
            C 174.00,2.52 228.00,2.00 228.00,2.00
              228.00,2.00 299.00,2.00 299.00,2.00
              299.00,2.00 332.00,2.00 332.00,2.00
              346.73,2.18 362.34,13.28 371.71,24.00
              377.94,31.13 384.70,41.05 387.91,50.00
              387.91,50.00 395.60,86.00 395.60,86.00
              395.60,86.00 410.80,163.00 410.80,163.00
              410.80,163.00 432.40,272.00 432.40,272.00
              432.40,272.00 439.40,307.00 439.40,307.00
              440.76,313.79 442.92,322.24 443.00,329.00
              443.30,355.93 417.25,383.96 390.00,384.00
              390.00,384.00 141.00,384.00 141.00,384.00
              141.00,384.00 129.00,383.08 129.00,383.08
              107.77,381.39 85.15,376.02 76.46,354.00
              72.35,343.57 72.88,332.96 73.00,322.00
              73.12,312.07 77.68,289.58 79.80,279.00
              79.80,279.00 91.58,217.00 91.58,217.00
              91.58,217.00 111.39,112.00 111.39,112.00
              111.39,112.00 118.39,75.00 118.39,75.00
              118.39,75.00 122.15,56.00 122.15,56.00
              128.21,33.31 151.18,8.65 174.00,2.52 Z
            M 228.13,33.21
            C 226.90,34.07 226.35,33.88 225.57,35.43
              224.92,36.74 225.01,39.51 225.00,41.00
              225.00,41.00 225.00,59.00 225.00,59.00
              225.03,60.62 224.96,63.06 226.02,64.40
              227.59,66.38 231.70,66.00 234.00,66.00
              234.00,66.00 281.00,66.00 281.00,66.00
              289.15,65.85 288.99,63.22 289.00,56.00
              289.00,56.00 289.00,42.00 289.00,42.00
              288.95,38.85 289.11,35.29 285.77,33.74
              283.32,32.59 272.34,33.00 269.00,33.21
              269.00,33.21 228.13,33.21 228.13,33.21 Z
            M 367.00,98.00
            C 367.00,98.00 157.00,98.00 157.00,98.00
              157.00,98.00 149.73,98.99 149.73,98.99
              149.73,98.99 146.60,109.00 146.60,109.00
              146.60,109.00 141.40,134.00 141.40,134.00
              141.40,134.00 125.00,215.00 125.00,215.00
              125.00,215.00 117.00,257.00 117.00,257.00
              117.00,257.00 397.00,257.00 397.00,257.00
              397.00,257.00 379.58,166.00 379.58,166.00
              379.58,166.00 367.00,98.00 367.00,98.00 Z
            M 187.00,289.30
            C 181.10,290.41 177.97,291.51 173.00,295.04
              157.58,306.02 155.43,329.10 168.18,342.96
              176.03,351.49 186.74,354.66 198.00,352.86
              222.01,349.02 232.01,319.64 217.47,301.00
              209.69,291.02 199.11,288.09 187.00,289.30 Z
            M 316.00,289.30
            C 310.28,290.41 305.71,292.22 301.01,295.76
              286.50,306.72 285.02,329.74 297.18,342.96
              305.03,351.49 315.74,354.66 327.00,352.86
              352.41,348.79 361.84,317.54 344.82,299.04
              336.92,290.45 327.20,288.18 316.00,289.30 Z
            M 311.00,417.00
            C 311.00,417.00 362.00,417.00 362.00,417.00
              362.00,417.00 372.72,443.00 372.72,443.00
              372.72,443.00 391.28,486.00 391.28,486.00
              391.28,486.00 402.00,513.00 402.00,513.00
              402.00,513.00 360.00,513.00 360.00,513.00
              360.00,513.00 352.63,512.01 352.63,512.01
              352.63,512.01 348.42,505.00 348.42,505.00
              348.42,505.00 341.69,490.00 341.69,490.00
              341.69,490.00 336.61,482.02 336.61,482.02
              336.61,482.02 329.00,481.00 329.00,481.00
              329.00,481.00 174.00,481.00 174.00,481.00
              174.00,481.00 165.80,503.00 165.80,503.00
              165.80,503.00 161.30,512.40 161.30,512.40
              161.30,512.40 154.00,514.00 154.00,514.00
              154.00,514.00 110.00,514.00 110.00,514.00
              110.00,514.00 125.70,477.00 125.70,477.00
              125.70,477.00 141.58,440.00 141.58,440.00
              141.58,440.00 151.64,418.99 151.64,418.99
              151.64,418.99 159.00,418.00 159.00,418.00
              159.00,418.00 203.00,418.00 203.00,418.00
              203.00,418.00 190.00,449.00 190.00,449.00
              190.00,449.00 324.00,449.00 324.00,449.00
              324.00,449.00 311.00,417.00 311.00,417.00 Z"
          ></path>
        </svg>
        <svg className="animationsvg" viewBox="0 0 517 517">
          <path
            d="M 27.00,470.50
            C 14.00,396.50 152.50,336.00 219.50,389.00
              307.50,443.50 419.50,414.50 458.00,370.00
              486.50,403.50 324.00,517.50 226.00,447.00
              141.50,384.50 69.00,434.00 27.00,470.50 Z
            M 209.49,46.51
            C 212.90,45.89 219.74,46.17 223.52,46.17
              234.84,46.17 240.57,45.00 250.88,51.11
              256.72,54.57 262.39,60.62 265.54,66.61
              267.43,70.20 271.19,74.67 264.43,74.79
              257.54,74.91 260.45,73.64 253.91,73.62
              253.91,73.62 238.71,73.62 238.71,73.62
              233.08,73.63 234.74,74.37 231.65,74.82
              231.65,74.82 227.61,74.82 227.61,74.82
              227.61,74.82 223.52,75.85 223.52,75.85
              223.52,75.85 217.14,76.69 217.14,76.69
              217.14,76.69 208.90,79.57 208.90,79.57
              199.90,82.48 191.11,85.81 182.62,90.00
              175.71,93.41 165.28,100.16 159.06,104.76
              157.44,105.96 150.87,111.33 149.36,111.26
              146.27,111.10 148.79,105.49 149.36,104.00
              149.36,104.00 154.96,87.64 154.96,87.64
              154.96,87.64 158.52,81.12 158.52,81.12
              165.82,66.35 174.84,57.53 190.37,51.60
              190.37,51.60 209.49,46.51 209.49,46.51 Z
            M 121.82,189.87
            C 121.82,189.87 124.46,186.92 124.46,186.92
              125.80,184.59 125.99,181.88 126.71,179.35
              126.71,179.35 130.49,165.33 130.49,165.33
              130.49,165.33 132.79,158.27 132.79,158.27
              133.89,153.50 135.70,144.36 139.08,140.95
              139.08,140.95 145.48,135.51 145.48,135.51
              158.09,125.33 162.98,122.50 177.24,115.04
              177.24,115.04 183.77,111.08 183.77,111.08
              191.34,107.26 207.00,101.84 215.33,99.51
              225.47,96.68 234.43,93.61 245.14,93.49
              245.14,93.49 255.61,92.93 255.61,92.93
              258.84,92.95 262.68,90.40 265.58,88.84
              265.58,88.84 284.89,78.47 284.89,78.47
              284.89,78.47 290.71,75.91 290.71,75.91
              290.71,75.91 315.28,66.16 315.28,66.16
              326.59,62.41 333.79,60.66 345.67,59.54
              349.01,59.23 348.25,58.46 353.27,58.38
              353.27,58.38 358.53,58.38 358.53,58.38
              362.30,57.79 360.48,57.28 366.13,57.27
              366.13,57.27 389.51,57.27 389.51,57.27
              394.55,57.28 392.84,57.68 396.52,58.36
              396.52,58.36 402.37,58.36 402.37,58.36
              406.27,58.49 405.85,59.06 408.79,59.48
              420.43,61.15 421.06,61.05 432.27,65.25
              432.27,65.25 438.44,67.35 438.44,67.35
              444.24,69.70 450.63,74.43 453.99,79.76
              456.61,83.93 457.56,88.81 458.81,93.48
              458.81,93.48 464.97,119.19 464.97,119.19
              464.97,119.19 469.05,137.86 469.05,137.86
              469.43,140.13 470.71,142.38 469.99,144.75
              469.31,147.00 466.07,146.23 464.32,145.87
              464.32,145.87 460.23,144.58 460.23,144.58
              460.23,144.58 452.04,143.17 452.04,143.17
              449.78,143.00 444.71,143.14 443.04,141.54
              440.84,139.42 441.77,132.95 438.48,131.05
              438.48,131.05 425.74,128.56 425.74,128.56
              425.74,128.56 421.65,127.37 421.65,127.37
              421.65,127.37 417.66,127.37 417.66,127.37
              417.66,127.37 414.03,126.27 414.03,126.27
              414.03,126.27 400.61,125.61 400.61,125.61
              393.82,125.60 396.29,124.45 389.51,124.44
              389.51,124.44 363.79,124.44 363.79,124.44
              358.14,124.45 359.96,124.97 356.19,125.55
              356.19,125.55 351.52,125.55 351.52,125.55
              351.52,125.55 341.63,126.35 341.63,126.35
              341.63,126.35 338.56,127.23 338.56,127.23
              338.56,127.23 335.15,127.64 335.15,127.64
              335.15,127.64 331.64,128.82 331.64,128.82
              331.64,128.82 315.28,133.77 315.28,133.77
              315.28,133.77 295.36,141.78 295.36,141.78
              295.36,141.78 284.30,147.56 284.30,147.56
              281.44,148.75 279.43,147.48 279.92,144.30
              279.92,144.30 280.79,141.38 280.79,141.38
              280.79,141.38 280.79,137.39 280.79,137.39
              280.79,137.39 281.81,134.32 281.81,134.32
              281.81,134.32 282.56,128.87 282.56,128.87
              282.89,127.34 283.05,124.03 283.71,122.96
              284.50,121.67 286.50,120.91 287.83,120.27
              290.90,118.80 294.37,116.39 297.74,116.26
              299.25,114.27 304.72,111.60 307.10,110.53
              314.63,107.14 322.43,104.22 330.42,102.14
              336.89,100.47 340.46,99.41 347.42,99.33
              347.42,99.33 358.53,98.16 358.53,98.16
              358.53,98.16 374.31,98.16 374.31,98.16
              374.31,98.16 390.09,98.16 390.09,98.16
              395.13,98.18 394.50,98.88 397.69,99.10
              397.69,99.10 410.55,100.06 410.55,100.06
              410.55,100.06 419.95,102.10 419.95,102.10
              419.95,102.10 425.74,102.93 425.74,102.93
              425.74,102.93 433.93,105.17 433.93,105.17
              433.79,103.11 432.38,96.23 431.26,94.68
              428.21,90.43 418.46,88.57 413.57,87.51
              413.57,87.51 410.50,86.63 410.50,86.63
              410.50,86.63 392.43,84.72 392.43,84.72
              392.43,84.72 362.62,84.72 362.62,84.72
              357.40,84.73 357.07,85.35 352.68,85.79
              352.68,85.79 343.94,86.55 343.94,86.55
              343.94,86.55 340.31,87.50 340.31,87.50
              340.31,87.50 324.72,90.83 324.72,90.83
              318.80,92.55 313.31,95.57 307.68,98.05
              294.40,103.91 288.15,106.80 275.53,114.28
              275.53,114.28 252.33,127.90 252.33,127.90
              246.18,132.98 250.00,142.90 242.22,148.36
              242.22,148.36 225.32,159.52 225.32,159.52
              225.32,159.52 214.75,166.68 214.75,166.68
              214.75,166.68 204.81,172.56 204.81,172.56
              204.81,172.56 191.37,181.21 191.37,181.21
              191.37,181.21 139.45,209.78 139.45,209.78
              139.45,209.78 131.15,214.74 131.15,214.74
              131.15,214.74 106.72,226.72 106.72,226.72
              106.72,226.72 100.78,230.10 100.78,230.10
              100.78,230.10 85.58,237.44 85.58,237.44
              83.01,238.66 76.28,241.33 74.50,242.71
              71.41,245.12 66.35,252.06 64.28,255.63
              63.20,257.48 61.35,261.33 60.01,262.71
              58.05,264.71 55.41,264.69 52.85,265.43
              52.85,265.43 37.65,269.72 37.65,269.72
              35.98,270.19 31.62,271.72 30.13,271.36
              27.58,270.75 28.71,268.50 29.25,266.87
              29.25,266.87 33.49,255.87 33.49,255.87
              36.87,247.80 45.56,234.25 51.27,227.50
              54.31,223.90 57.13,219.85 62.20,219.66
              63.89,217.43 70.97,214.84 73.79,213.22
              73.79,213.22 106.62,196.87 106.62,196.87
              110.61,194.76 117.43,190.03 121.82,189.87 Z
            M 430.42,345.25
            C 430.42,345.25 255.66,345.25 255.66,345.25
              255.66,345.25 140.52,345.25 140.52,345.25
              140.52,345.25 66.88,345.25 66.88,345.25
              66.88,345.25 30.05,345.25 30.05,345.25
              23.97,345.15 14.89,339.43 11.18,334.71
              8.80,331.70 6.89,327.27 5.51,323.69
              4.25,320.41 3.23,318.50 3.17,314.87
              3.17,314.87 3.17,298.52 3.17,298.52
              3.17,297.00 2.97,294.84 4.10,293.68
              5.39,292.37 8.43,292.25 10.18,291.83
              10.18,291.83 27.03,287.76 27.03,287.76
              27.03,287.76 49.34,281.95 49.34,281.95
              49.34,281.95 58.69,278.44 58.69,278.44
              58.69,278.44 67.46,276.00 67.46,276.00
              67.46,276.00 76.81,273.03 76.81,273.03
              76.81,273.03 95.10,267.19 95.10,267.19
              95.10,267.19 106.04,263.62 106.04,263.62
              106.04,263.62 122.40,257.24 122.40,257.24
              122.40,257.24 134.09,253.12 134.09,253.12
              134.09,253.12 138.01,251.96 138.01,251.96
              138.01,251.96 160.98,242.15 160.98,242.15
              160.98,242.15 178.93,235.05 178.93,235.05
              178.93,235.05 190.64,229.68 190.64,229.68
              190.64,229.68 194.30,227.58 194.30,227.58
              194.30,227.58 207.13,221.97 207.13,221.97
              207.13,221.97 229.36,210.92 229.36,210.92
              229.36,210.92 250.38,201.91 250.38,201.91
              250.38,201.91 275.78,190.83 275.78,190.83
              275.78,190.83 298.91,182.61 298.91,182.61
              298.91,182.61 309.43,178.32 309.43,178.32
              309.43,178.32 334.66,170.67 334.66,170.67
              334.66,170.67 343.82,168.57 343.82,168.57
              343.82,168.57 357.95,165.01 357.95,165.01
              357.95,165.01 361.35,164.48 361.35,164.48
              361.35,164.48 369.64,162.05 369.64,162.05
              369.64,162.05 388.34,158.92 388.34,158.92
              388.34,158.92 392.43,158.92 392.43,158.92
              392.43,158.92 396.52,157.81 396.52,157.81
              396.52,157.81 402.95,157.81 402.95,157.81
              407.57,157.66 406.36,156.58 412.30,156.57
              412.30,156.57 435.68,156.57 435.68,156.57
              441.33,156.58 439.51,157.10 443.28,157.68
              443.28,157.68 447.95,157.68 447.95,157.68
              451.85,157.81 451.58,158.52 454.38,158.95
              454.38,158.95 458.47,158.95 458.47,158.95
              468.16,160.33 474.54,162.48 483.61,165.55
              489.23,167.46 494.94,168.89 500.02,172.15
              504.53,175.03 510.60,181.16 512.16,186.53
              512.30,187.72 512.24,189.21 512.16,190.45
              512.16,190.45 512.16,200.96 512.16,200.96
              512.17,206.26 508.60,211.83 505.87,216.20
              498.83,227.48 486.14,240.26 477.03,250.38
              458.46,270.99 437.54,298.78 432.32,326.56
              432.32,326.56 431.53,334.15 431.53,334.15
              431.17,337.85 430.43,336.45 430.42,342.33
              430.42,342.33 430.42,345.25 430.42,345.25 Z
            M 356.19,228.65
            C 349.25,230.94 351.71,236.80 353.25,241.85
              353.25,241.85 354.66,247.11 354.66,247.11
              355.02,248.99 356.49,252.07 354.66,253.63
              353.38,254.92 349.35,255.38 347.42,255.76
              347.42,255.76 331.64,259.34 331.64,259.34
              329.39,259.65 326.27,260.58 324.62,258.61
              320.79,254.02 320.85,241.41 314.11,240.75
              309.75,240.33 307.57,242.84 307.76,247.11
              307.90,250.24 312.44,260.65 313.73,264.64
              314.43,266.81 315.50,270.33 317.26,271.93
              320.33,274.42 326.83,272.77 330.47,271.93
              330.47,271.93 341.00,270.26 341.00,270.26
              341.00,270.26 350.35,268.25 350.35,268.25
              353.90,267.78 364.48,266.62 367.29,265.34
              369.87,264.16 371.79,261.71 371.68,258.79
              371.61,256.93 369.41,250.36 368.72,248.28
              367.06,243.36 365.47,231.55 360.81,229.02
              359.37,228.23 357.75,228.44 356.19,228.65 Z"
          ></path>
        </svg>
      </div>
      <div style={{ height: "100px", width: "600px", margin: "auto" }}>
        {props.text ? <span style={{fontSize:"1em"}}>{props.text}</span> : undefined}
        {props.text ? undefined : <svg className="textsvg" viewBox="0 0 860 65">
          <path
            d="M 165.00,2.00
            C 165.00,2.00 172.00,2.00 172.00,2.00
              172.00,2.00 172.00,18.00 172.00,18.00
              174.48,16.04 175.75,14.81 179.00,14.23
              203.01,9.91 201.48,55.94 178.00,49.57
              175.33,48.85 174.09,47.64 172.00,46.00
              170.48,49.66 168.66,48.95 165.00,49.00
              165.00,49.00 165.00,2.00 165.00,2.00 Z
            M 460.00,2.00
            C 460.00,2.00 466.00,2.00 466.00,2.00
              466.00,2.00 466.00,49.00 466.00,49.00
              462.56,48.88 461.40,49.37 460.00,46.00
              455.51,49.54 453.82,50.29 448.00,49.96
              430.53,48.96 430.53,15.04 448.00,14.04
              453.82,13.71 455.51,14.46 460.00,18.00
              460.00,18.00 460.00,2.00 460.00,2.00 Z
            M 651.00,15.00
            C 651.32,0.96 657.66,2.00 669.00,2.00
              669.00,2.00 669.00,7.00 669.00,7.00
              662.29,7.31 658.61,7.49 658.00,15.00
              658.00,15.00 667.00,15.00 667.00,15.00
              667.00,15.00 667.00,20.00 667.00,20.00
              667.00,20.00 658.00,20.00 658.00,20.00
              658.00,20.00 658.00,49.00 658.00,49.00
              658.00,49.00 651.00,49.00 651.00,49.00
              651.00,49.00 651.00,20.00 651.00,20.00
              651.00,20.00 646.00,20.00 646.00,20.00
              646.00,20.00 646.00,15.00 646.00,15.00
              646.00,15.00 651.00,15.00 651.00,15.00 Z
            M 773.00,2.00
            C 773.00,2.00 779.00,2.00 779.00,2.00
              779.00,2.00 779.00,49.00 779.00,49.00
              775.56,48.88 774.40,49.37 773.00,46.00
              769.60,48.67 768.46,49.70 764.00,49.96
              742.19,51.19 743.52,15.04 761.00,14.04
              766.82,13.71 768.51,14.46 773.00,18.00
              773.00,18.00 773.00,2.00 773.00,2.00 Z
            M 2.00,49.00
            C 2.00,49.00 14.81,15.00 14.81,15.00
              16.01,11.91 17.75,5.25 21.22,4.30
              27.48,2.58 29.05,8.55 30.80,13.00
              30.80,13.00 44.00,49.00 44.00,49.00
              44.00,49.00 37.70,48.01 37.70,48.01
              37.70,48.01 31.61,38.02 31.61,38.02
              31.61,38.02 13.00,37.00 13.00,37.00
              13.00,37.00 10.00,49.00 10.00,49.00
              10.00,49.00 2.00,49.00 2.00,49.00 Z
            M 242.00,5.00
            C 242.00,5.00 249.00,5.00 249.00,5.00
              249.00,5.00 249.00,15.00 249.00,15.00
              249.00,15.00 260.00,15.00 260.00,15.00
              260.00,15.00 260.00,20.00 260.00,20.00
              260.00,20.00 249.00,20.00 249.00,20.00
              249.00,24.44 247.92,38.53 250.60,41.49
              252.85,43.98 256.92,43.93 260.00,44.00
              260.00,44.00 260.00,49.00 260.00,49.00
              256.49,49.00 250.03,49.44 247.06,47.83
              239.97,43.97 242.00,27.24 242.00,20.00
              242.00,20.00 238.00,20.00 238.00,20.00
              238.00,20.00 238.00,15.00 238.00,15.00
              238.00,15.00 242.00,15.00 242.00,15.00
              242.00,15.00 242.00,5.00 242.00,5.00 Z
            M 24.00,12.00
            C 20.53,16.02 16.96,26.67 16.00,32.00
              16.00,32.00 31.00,32.00 31.00,32.00
              31.00,32.00 24.00,12.00 24.00,12.00 Z
            M 56.00,18.00
            C 62.63,12.78 73.60,11.54 77.26,21.00
              78.57,24.37 78.00,44.00 78.00,49.00
              78.00,49.00 72.00,49.00 72.00,49.00
              72.00,43.45 73.13,27.11 70.26,23.14
              66.48,17.88 59.88,19.83 57.17,25.02
              55.26,28.68 56.00,44.03 56.00,49.00
              56.00,49.00 49.00,49.00 49.00,49.00
              49.00,49.00 49.00,15.00 49.00,15.00
              52.66,15.05 54.48,14.34 56.00,18.00 Z
            M 111.00,45.00
            C 107.60,47.67 106.46,48.70 102.00,48.96
              80.34,50.19 81.59,15.03 99.00,14.04
              104.82,13.71 106.51,14.46 111.00,18.00
              112.40,14.63 113.56,15.12 117.00,15.00
              117.00,15.00 117.00,43.00 117.00,43.00
              116.99,47.60 117.03,51.78 114.59,55.91
              113.23,58.19 111.41,59.83 108.98,60.91
              105.20,62.60 94.56,62.77 91.60,59.49
              90.10,57.83 90.17,56.06 90.00,54.00
              100.68,56.41 107.97,59.15 111.00,45.00 Z
            M 156.00,42.00
            C 155.87,43.62 155.93,45.15 154.98,46.58
              152.15,50.83 140.33,50.56 136.00,49.20
              128.05,46.70 124.76,38.77 125.04,31.00
              125.45,19.98 132.08,13.75 143.00,14.02
              146.32,14.10 149.11,14.48 151.79,16.65
              157.02,20.88 157.00,26.94 157.00,33.00
              157.00,33.00 132.00,33.00 132.00,33.00
              134.57,48.43 145.65,43.84 156.00,42.00 Z
            M 212.00,14.65
            C 217.99,13.41 225.05,13.30 229.47,18.21
              236.70,26.24 235.60,45.67 224.00,49.35
              221.95,50.00 219.15,50.04 217.00,49.98
              198.49,49.53 196.92,21.04 212.00,14.65 Z
            M 295.00,42.00
            C 294.87,43.62 294.93,45.15 293.98,46.58
              291.15,50.83 279.33,50.56 275.00,49.20
              267.05,46.70 263.76,38.77 264.04,31.00
              264.45,19.98 271.08,13.75 282.00,14.02
              285.32,14.10 288.11,14.48 290.79,16.65
              296.02,20.88 296.00,26.94 296.00,33.00
              296.00,33.00 271.00,33.00 271.00,33.00
              273.57,48.43 284.65,43.84 295.00,42.00 Z
            M 404.00,42.00
            C 403.87,43.62 403.93,45.15 402.98,46.58
              400.15,50.83 388.33,50.56 384.00,49.20
              376.05,46.70 372.76,38.77 373.04,31.00
              373.45,19.98 380.08,13.75 391.00,14.02
              394.32,14.10 397.11,14.48 399.79,16.65
              405.02,20.88 405.00,26.94 405.00,33.00
              405.00,33.00 380.00,33.00 380.00,33.00
              382.57,48.43 393.65,43.84 404.00,42.00 Z
            M 420.00,18.00
            C 425.80,13.43 426.93,14.01 434.00,14.00
              434.00,14.00 434.00,20.00 434.00,20.00
              434.00,20.00 426.02,20.52 426.02,20.52
              426.02,20.52 420.74,26.00 420.74,26.00
              420.74,26.00 420.00,49.00 420.00,49.00
              420.00,49.00 413.00,49.00 413.00,49.00
              413.00,49.00 413.00,15.00 413.00,15.00
              416.66,15.05 418.48,14.34 420.00,18.00 Z
            M 505.00,42.00
            C 504.87,43.62 504.93,45.15 503.98,46.58
              501.15,50.83 489.33,50.56 485.00,49.20
              477.05,46.70 473.76,38.77 474.04,31.00
              474.45,19.98 481.08,13.75 492.00,14.02
              495.32,14.10 498.11,14.48 500.79,16.65
              506.02,20.88 506.00,26.94 506.00,33.00
              506.00,33.00 481.00,33.00 481.00,33.00
              483.57,48.43 494.65,43.84 505.00,42.00 Z
            M 521.00,18.00
            C 527.63,12.78 538.60,11.54 542.26,21.00
              543.57,24.37 543.00,44.00 543.00,49.00
              543.00,49.00 537.00,49.00 537.00,49.00
              537.00,43.45 538.13,27.11 535.26,23.14
              531.48,17.88 524.88,19.83 522.17,25.02
              520.26,28.68 521.00,44.03 521.00,49.00
              521.00,49.00 514.00,49.00 514.00,49.00
              514.00,49.00 514.00,15.00 514.00,15.00
              517.66,15.05 519.48,14.34 521.00,18.00 Z
            M 596.00,45.00
            C 592.60,47.67 591.46,48.70 587.00,48.96
              565.34,50.19 566.59,15.03 584.00,14.04
              589.82,13.71 591.51,14.46 596.00,18.00
              597.40,14.63 598.56,15.12 602.00,15.00
              602.00,15.00 602.00,43.00 602.00,43.00
              601.99,47.60 602.03,51.78 599.59,55.91
              598.23,58.19 596.41,59.83 593.98,60.91
              590.20,62.60 579.56,62.77 576.60,59.49
              575.10,57.83 575.17,56.06 575.00,54.00
              585.68,56.41 592.97,59.15 596.00,45.00 Z
            M 641.00,42.00
            C 640.94,43.72 641.10,45.85 640.01,47.30
              637.29,50.89 623.82,50.54 620.00,48.99
              611.71,45.63 609.66,38.12 610.04,30.00
              610.94,10.79 631.63,11.68 637.78,17.39
              642.34,21.62 642.00,27.34 642.00,33.00
              642.00,33.00 617.00,33.00 617.00,33.00
              619.89,48.17 630.36,43.64 641.00,42.00 Z
            M 719.00,17.00
            C 722.77,14.14 725.29,13.78 730.00,14.04
              733.08,14.22 735.28,14.75 737.35,17.23
              742.05,22.83 741.00,41.49 741.00,49.00
              741.00,49.00 734.00,49.00 734.00,49.00
              734.00,43.04 735.32,26.41 731.49,22.31
              727.69,18.25 721.53,20.62 719.17,25.04
              717.21,28.72 718.00,44.02 718.00,49.00
              718.00,49.00 711.00,49.00 711.00,49.00
              711.00,49.00 711.00,15.00 711.00,15.00
              711.00,15.00 719.00,17.00 719.00,17.00 Z
            M 818.00,42.00
            C 817.94,43.72 818.10,45.85 817.01,47.30
              814.29,50.89 800.82,50.54 797.00,48.99
              788.71,45.63 786.66,38.12 787.04,30.00
              787.94,10.79 808.63,11.68 814.78,17.39
              819.34,21.62 819.00,27.34 819.00,33.00
              819.00,33.00 794.00,33.00 794.00,33.00
              796.89,48.17 807.36,43.64 818.00,42.00 Z
            M 835.00,17.00
            C 838.77,14.14 841.29,13.78 846.00,14.04
              849.08,14.22 851.28,14.75 853.35,17.23
              858.05,22.83 857.00,41.49 857.00,49.00
              857.00,49.00 850.00,49.00 850.00,49.00
              850.00,43.04 851.32,26.41 847.49,22.31
              843.69,18.25 837.53,20.62 835.17,25.04
              833.21,28.72 834.00,44.02 834.00,49.00
              834.00,49.00 827.00,49.00 827.00,49.00
              827.00,49.00 827.00,15.00 827.00,15.00
              827.00,15.00 835.00,17.00 835.00,17.00 Z
            M 321.00,15.00
            C 321.00,15.00 328.00,15.00 328.00,15.00
              328.00,15.00 334.00,38.00 334.00,38.00
              334.00,38.00 340.00,15.00 340.00,15.00
              340.00,15.00 347.30,15.99 347.30,15.99
              347.30,15.99 350.37,23.00 350.37,23.00
              350.37,23.00 355.00,39.00 355.00,39.00
              355.00,39.00 358.87,23.00 358.87,23.00
              358.87,23.00 361.72,15.99 361.72,15.99
              361.72,15.99 367.00,15.00 367.00,15.00
              367.00,15.00 359.00,49.00 359.00,49.00
              359.00,49.00 351.00,49.00 351.00,49.00
              351.00,49.00 344.00,23.00 344.00,23.00
              344.00,23.00 338.00,49.00 338.00,49.00
              338.00,49.00 330.72,48.01 330.72,48.01
              330.72,48.01 327.12,38.00 327.12,38.00
              327.12,38.00 321.00,15.00 321.00,15.00 Z
            M 672.00,15.00
            C 672.00,15.00 678.00,15.00 678.00,15.00
              678.00,21.33 676.50,38.23 681.42,42.26
              685.56,45.66 690.52,43.01 692.91,38.98
              695.99,33.80 695.00,21.30 695.00,15.00
              695.00,15.00 701.00,15.00 701.00,15.00
              701.00,15.00 701.00,49.00 701.00,49.00
              697.56,48.88 696.40,49.37 695.00,46.00
              692.51,47.96 691.25,49.18 688.00,49.77
              675.29,52.08 672.02,45.09 672.00,34.00
              672.00,34.00 672.00,15.00 672.00,15.00 Z
            M 99.04,20.43
            C 88.97,24.81 91.31,45.77 103.98,42.68
              111.82,40.77 112.53,27.35 107.57,22.31
              105.03,19.73 102.31,19.97 99.04,20.43 Z
            M 151.00,28.00
            C 147.68,16.85 135.28,17.12 132.00,28.00
              132.00,28.00 151.00,28.00 151.00,28.00 Z
            M 178.02,20.60
            C 166.79,26.88 172.12,47.99 183.96,43.26
              192.36,39.91 192.98,17.78 178.02,20.60 Z
            M 215.02,20.60
            C 203.78,26.90 209.12,47.86 220.98,43.40
              229.86,40.06 230.10,17.56 215.02,20.60 Z
            M 290.00,28.00
            C 286.68,16.85 274.28,17.12 271.00,28.00
              271.00,28.00 290.00,28.00 290.00,28.00 Z
            M 399.00,28.00
            C 395.68,16.85 383.28,17.12 380.00,28.00
              380.00,28.00 399.00,28.00 399.00,28.00 Z
            M 448.09,20.43
            C 438.82,24.60 440.22,42.36 449.04,43.76
              462.69,45.92 464.67,18.25 448.09,20.43 Z
            M 500.00,28.00
            C 496.68,16.85 484.28,17.12 481.00,28.00
              481.00,28.00 500.00,28.00 500.00,28.00 Z
            M 584.04,20.43
            C 573.97,24.81 576.31,45.77 588.98,42.68
              596.82,40.77 597.53,27.35 592.57,22.31
              590.03,19.73 587.31,19.97 584.04,20.43 Z
            M 636.00,28.00
            C 632.68,16.85 620.28,17.12 617.00,28.00
              617.00,28.00 636.00,28.00 636.00,28.00 Z
            M 761.09,20.43
            C 751.82,24.60 753.22,42.36 762.04,43.76
              775.69,45.92 777.67,18.25 761.09,20.43 Z
            M 813.00,28.00
            C 809.68,16.85 797.28,17.12 794.00,28.00
              794.00,28.00 813.00,28.00 813.00,28.00 Z"
          ></path>
        </svg>}
      </div>
    </>
  );
}
